<template><NumberRangeFilter field="permeability" label="Проницаемость" @filter="$emit('filter',$event)"/></template>
<script>
import NumberRangeFilter from './NumberRangeFilter.vue'
export default { name:'PermeabilityFilter', components:{NumberRangeFilter} }
</script>
